import React/*, { useState, useEffect } */ from "react";
import { NavbarComponent } from "../components";

function NavbarContainer({ itemsArray }) {
//   const [arr, setArr] = useState([]);
//   useEffect(() => {
//     let itemsArr = [];
//     itemsArray.map((items, i) => {
//       itemsArr.push(items);
//       if (itemsArray.length !== i + 1) itemsArr.push(false);
//     });
//     setArr(itemsArr);
//   }, [itemsArray]);
  return <NavbarComponent />;
}

export default NavbarContainer;
